module.exports = __webpack_public_path__ + "img/inv150.2.406cab7e.png";